export default __webpack_public_path__ + "static/media/head01_ja_pc@2x.d027d7c7.png";